import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    // ✅ STANDARD VBOT-METHODEN
    async addVbot(vbot) {
        const response = await axios.post(API_URL + "/vbot", vbot, { headers: authHeader() });
        return response.data;
    },

    async getVbots() {
        const response = await axios.get(API_URL + "/vbot", { headers: authHeader() });
        return response.data;
    },

    async getVbotById(licenseKey) {
        const response = await axios.get(API_URL + "/vbot/" + licenseKey, { headers: authHeader() });
        return response.data;
    },

    async updateVbot(vbot) {
        const response = await axios.patch(API_URL + "/vbot/" + vbot.license_Key, vbot, { headers: authHeader() });
        return response.data;
    },

    async deleteVbot(vbotId) {
        await axios.delete(API_URL + "/vbot/" + vbotId, { headers: authHeader() });
    },

    // ✅ PHONEBOT METHODEN (FÜR SUPER-ADMIN) - FIXED
    async getPhonebots() {
        const response = await axios.get(API_URL + "/phonebot", { headers: authHeader() });
        // ✅ FIX: Extract the actual data array from the response
        // Backend returns: { message: "...", data: [...] }
        // We need just the data array: [...]
        return response.data.data;
    },

    async updatePhonebot(phonebot) {
        const response = await axios.patch(API_URL + "/phonebot/" + phonebot.license_Key, phonebot, { headers: authHeader() });
        return response.data;
    },

    // ✅ PROMPT-GENERIERUNG
    async generatePrompt(vbotId, promptData) {
        const response = await axios.post(
            API_URL + "/vbot/" + vbotId + "/generate-prompt", 
            {
                current_prompt: promptData.current_prompt
            }, 
            { headers: authHeader() }
        );
        return response.data;
    },

    // ✅ GUEST VBOT METHODS
    async getVbotByIdForGuest(licenseKey) {
        const response = await axios.get(API_URL + "/vbotbyguest/" + licenseKey, { headers: authHeader() });
        return response.data;
    },

    async updateVbotByGuest(vbot) {
        const response = await axios.patch(API_URL + "/vbotbyguest/" + vbot.license_Key, vbot, { headers: authHeader() });
        return response.data;
    }
};